export const ORGANOGRAMA_LIST = 'ORGANOGRAMA_LIST';
export const ORGANOGRAMA_LIST_START = 'ORGANOGRAMA_LIST_START';
export const ORGANOGRAMA_LIST_SUCCESS = 'ORGANOGRAMA_LIST_SUCCESS';
export const ORGANOGRAMA_LIST_ERROR = 'ORGANOGRAMA_LIST_ERROR';
